export const DOMAIN_NAME = window.location.hostname
  .split('.')
  .reverse()
  .slice(0, 2)
  .reverse()
  .join('.');
